class FloatingProductButton {
  constructor() {
    this.button = document.getElementById('floatingProductBtn');
    this.scrollThreshold = 300;
    this.isVisible = false;
    this.ticking = false;

    if (this.button) {
      this.init();
    }
  }

  init() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(this.updateButton.bind(this));
      this.ticking = true;
    }
  }

  handleResize() {
    this.updateButton();
  }

  updateButton() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldShow = scrollTop > this.scrollThreshold;

    if (shouldShow !== this.isVisible) {
      this.isVisible = shouldShow;

      if (this.isVisible) {
        this.button.classList.add('show');
      } else {
        this.button.classList.remove('show');
      }
    }

    this.ticking = false;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new FloatingProductButton();
});